// import { useEffect, useState, useCallback } from "react";
// import {
//   Box,
//   Card,
//   Typography,
//   IconButton,
//   TextField,
//   Button,
//   Divider,
//   CircularProgress,
//   Tooltip,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   TableContainer,
//   Table,
//   TableHead,
//   TableBody,
//   TableRow,
//   TableCell,
//   Paper,
//   Chip,
//   Tabs,
//   Tab,
// } from "@mui/material";
// import { Delete, Edit, Save, Close, Refresh, Add } from "@mui/icons-material";
// import { styled, useTheme } from "@mui/material/styles";
// import apiService from "Network/apiService";
// import { API_ENDPOINTS } from "Network/apiEndpoints";
// import { useToast } from "OtherReusableFunctionality/ToastContext";
// import { usePageTitle } from "contexts/PageTitleContext";
// import { useDeleteConfirmation } from "contexts/DeleteConfirmationContext";
// import Invoice from "icons/duotone/Invoice";

// const PageContainer = styled(Box)(({ theme }) => ({
//   padding: theme.spacing(2),
// }));

// const HeaderCard = styled(Card)(({ theme }) => ({
//   padding: theme.spacing(2),
//   marginBottom: theme.spacing(2),
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "space-between",
// }));

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   fontSize: "0.875rem",
//   padding: "12px 16px",
//   "&.header": {
//     fontWeight: 600,
//     backgroundColor: theme.palette.grey[100],
//   },
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   "&:nth-of-type(even)": {
//     backgroundColor: theme.palette.action.hover,
//   },
//   "&:hover": {
//     backgroundColor: theme.palette.action.hover,
//   },
// }));

// const TableCard = styled(Card)(({ theme }) => ({
//   padding: theme.spacing(2),
// }));

// const Muted = styled(Typography)(({ theme }) => ({
//   color: theme.palette.text.secondary,
// }));

// const InvoiceDetails = () => {
//   const theme = useTheme();
//   const toast = useToast();
//   const { setPageTitle } = usePageTitle();
//   const { showDeleteConfirmation } = useDeleteConfirmation();

//   // Tab state
//   const [currentTab, setCurrentTab] = useState(0);

//   // Loading state
//   const [loading, setLoading] = useState(false);

//   // Dropdown data
//   const [categories, setCategories] = useState([]);
//   const [subcategories, setSubcategories] = useState([]);
//   const [faqs, setFaqs] = useState([]);
//   const [loadingCategories, setLoadingCategories] = useState(false);
//   const [loadingSubcategories, setLoadingSubcategories] = useState(false);
//   const [loadingFaqs, setLoadingFaqs] = useState(false);

//   // Category CRUD states
//   const [categoryItems, setCategoryItems] = useState([]);
//   const [categoryDialogOpen, setCategoryDialogOpen] = useState(false);
//   const [categoryEditingId, setCategoryEditingId] = useState(null);
//   const [categoryFormData, setCategoryFormData] = useState({ name: "" });
//   const [categorySaving, setCategorySaving] = useState(false);
//   const [categoryDeletingId, setCategoryDeletingId] = useState(null);

//   // Subcategory CRUD states
//   const [subcategoryItems, setSubcategoryItems] = useState([]);
//   const [subcategoryDialogOpen, setSubcategoryDialogOpen] = useState(false);
//   const [subcategoryEditingId, setSubcategoryEditingId] = useState(null);
//   const [subcategoryFormData, setSubcategoryFormData] = useState({ name: "", category_id: "", sequence: "" });
//   const [subcategorySaving, setSubcategorySaving] = useState(false);
//   const [subcategoryDeletingId, setSubcategoryDeletingId] = useState(null);

//   // FAQ CRUD states
//   const [faqItems, setFaqItems] = useState([]);
//   const [faqDialogOpen, setFaqDialogOpen] = useState(false);
//   const [faqEditingId, setFaqEditingId] = useState(null);
//   const [faqFormData, setFaqFormData] = useState({ question: "", category_id: "", subcategory_id: "" });
//   const [faqSaving, setFaqSaving] = useState(false);
//   const [faqDeletingId, setFaqDeletingId] = useState(null);

//   useEffect(() => {
//     setPageTitle("Invoice");
//     fetchCategories();
//     if (currentTab === 0) {
//       fetchCategoryItems();
//     } else if (currentTab === 1) {
//       fetchSubcategoryItems();
//     } else if (currentTab === 2) {
//       fetchFaqItems();
//     }
//   }, [setPageTitle, currentTab]);

//   const userId = localStorage.getItem("user_id") || "1";

//   // Fetch categories
//   const fetchCategories = async () => {
//     setLoadingCategories(true);
//     try {
//       const response = await apiService.get(
//         `${API_ENDPOINTS.Get_Invoice}`
//       );
//       if (response?.success && response?.data) {
//         const categoryList = Array.isArray(response.data)
//           ? response.data
//           : response.data.categories || response.data.Category || [];
//         setCategories(categoryList.filter((cat) => !cat.is_deleted && cat.status === "Active"));
//       }
//     } catch (error) {
//       console.error("Error fetching categories:", error);
//       toast.showError("Failed to load categories");
//     } finally {
//       setLoadingCategories(false);
//     }
//   };

  

//   // Fetch subcategories when category_id changes in FAQ form (for edit mode)
//   useEffect(() => {
//     if (faqDialogOpen && faqFormData.category_id) {
//       fetchSubcategories(Number(faqFormData.category_id));
//     }
//   }, [faqDialogOpen, faqFormData.category_id, fetchSubcategories]);


//   // Category CRUD functions
//   const handleCategoryOpenDialog = (item = null) => {
//     if (item) {
//       setCategoryEditingId(item.id);
//       setCategoryFormData({
//         name: item.name || "",
//       });
//     } else {
//       setCategoryEditingId(null);
//       setCategoryFormData({ name: "" });
//     }
//     setCategoryDialogOpen(true);
//   };

//   const handleCategoryCloseDialog = () => {
//     setCategoryDialogOpen(false);
//     setCategoryEditingId(null);
//     setCategoryFormData({ name: "" });
//   };

//   const handleCategorySave = async () => {
//     if (!categoryFormData.name?.trim()) {
//       toast.showError("Category name is required");
//       return;
//     }

//     setCategorySaving(true);
//     try {
//       const formDataPayload = new FormData();
//       formDataPayload.append('name', categoryFormData.name.trim());
//       formDataPayload.append('user_id', userId);

//       let response;
//       if (categoryEditingId) {
//         formDataPayload.append('category_id', categoryEditingId);
//         response = await apiService.put(API_ENDPOINTS.Update_Invoice, formDataPayload, undefined, 'multipart/form-data');
//       } else {
//         response = await apiService.post(API_ENDPOINTS.Add_Invoice, formDataPayload, undefined, 'multipart/form-data');
//       }

//       if (response?.success) {
//         toast.showSuccess(categoryEditingId ? "Category updated successfully" : "Category added successfully");
//         handleCategoryCloseDialog();
//         // Refresh the category list immediately
//         await fetchCategoryItems();
//         await fetchCategories(); // Refresh dropdown
//       } else {
//         toast.showError(response?.message || "Failed to save category");
//       }
//     } catch (error) {
//       console.error("Error saving category:", error);
//       const errorMessage = error?.response?.data?.message || error?.message || "Failed to save category";
//       toast.showError(errorMessage);
//     } finally {
//       setCategorySaving(false);
//     }
//   };



//   // Subcategory CRUD functions
//   const handleSubcategoryOpenDialog = (item = null) => {
//     if (item) {
//       setSubcategoryEditingId(item.id);
//       setSubcategoryFormData({
//         name: item.name || "",
//         category_id: item.category_id || item.category?.id || "",
//         sequence: item.sequence || "",
//       });
//     } else {
//       setSubcategoryEditingId(null);
//       setSubcategoryFormData({ name: "", category_id: "", sequence: "" });
//     }
//     setSubcategoryDialogOpen(true);
//   };

//   const handleSubcategoryCloseDialog = () => {
//     setSubcategoryDialogOpen(false);
//     setSubcategoryEditingId(null);
//     setSubcategoryFormData({ name: "", category_id: "", sequence: "" });
//   };

  
//   // FAQ CRUD functions
//   const handleFaqOpenDialog = (item = null) => {
//     if (item) {
//       const categoryId = item.category?.id ? String(item.category.id) : "";
//       const subcategoryId = item.sub_category?.id ? String(item.sub_category.id) : "";
      
//       // Ensure the category from the FAQ item is included in the categories list
//       // (even if it's deleted/inactive, so it shows in the dropdown when editing)
//       if (item.category && categoryId) {
//         setCategories(prev => {
//           const categoryExists = prev.some(cat => String(cat.id) === categoryId);
//           if (!categoryExists) {
//             // Add the category temporarily to the list so it appears in the dropdown
//             return [...prev, item.category];
//           }
//           return prev;
//         });
//       }
      
//       setFaqEditingId(item.id);
//       setFaqFormData({
//         question: item.question || item.prompt || "",
//         category_id: categoryId,
//         subcategory_id: subcategoryId,
//       });
      
//       // Fetch subcategories if category is present
//       if (categoryId) {
//         fetchSubcategories(Number(categoryId));
//       }
//     } else {
//       setFaqEditingId(null);
//       setFaqFormData({ question: "", category_id: "", subcategory_id: "" });
//     }
//     setFaqDialogOpen(true);
//   };

//   const handleFaqCloseDialog = () => {
//     setFaqDialogOpen(false);
//     setFaqEditingId(null);
//     setFaqFormData({ question: "", category_id: "", subcategory_id: "" });
//   };

 
//   const handleFaqDelete = async (id) => {
//     const confirmed = await showDeleteConfirmation({
//       title: "Delete FAQ",
//       message: "Are you sure you want to delete this FAQ?",
//       confirmButtonText: "Delete",
//       cancelButtonText: "Cancel"
//     });
    
//     if (!confirmed) return;
    
//     setFaqDeletingId(id);
//     try {
//       const response = await apiService.delete(
//         `${API_ENDPOINTS.Delete_Invoice}?invoice_details_of_company_id=${id}`
//       );
//       if (response?.success) {
//         toast.showSuccess("FAQ deleted successfully");
//         fetchFaqItems();
//       } else {
//         toast.showError(response?.message || "Failed to delete FAQ");
//       }
//     } catch (error) {
//       console.error("Error deleting FAQ:", error);
//       toast.showError(error?.message || "Failed to delete FAQ");
//     } finally {
//       setFaqDeletingId(null);
//     }
//   };


//   // Render Category Tab
//   const renderCategoryTab = () => (
//     <>
//       <HeaderCard>
//         <Box>
//           <Typography variant="h6" fontWeight={700}>
//             Categories
//           </Typography>
//           <Muted variant="body2">Manage disease advisory categories</Muted>
//         </Box>
//         <Box sx={{ display: "flex", gap: 2 }}>
//           <Button
//             startIcon={<Add />}
//             variant="contained"
//             onClick={() => handleCategoryOpenDialog()}
//           >
//             Add Category
//           </Button>
//           <Button startIcon={<Refresh />} variant="outlined" onClick={fetchCategoryItems} disabled={loading}>
//             {loading ? "Refreshing..." : "Refresh"}
//           </Button>
//         </Box>
//       </HeaderCard>

//       <TableCard>
//         <TableContainer component={Paper} sx={{ borderRadius: 2, overflow: "hidden" }}>
//           <Table>
//             <TableHead>
//               <TableRow>
//                 <StyledTableCell className="header" align="center" sx={{ width: '100px' }}>Sr No</StyledTableCell>
//                 <StyledTableCell className="header" align="center">Category Name</StyledTableCell>
//                 <StyledTableCell className="header" align="center" sx={{ width: '150px' }}>Actions</StyledTableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {loading ? (
//                 <TableRow>
//                   <TableCell colSpan={3} align="center" sx={{ py: 5 }}>
//                     <CircularProgress size={28} />
//                   </TableCell>
//                 </TableRow>
//               ) : categoryItems.length === 0 ? (
//                 <TableRow>
//                   <TableCell colSpan={3} align="center" sx={{ py: 4 }}>
//                     <Typography variant="body2" color="text.secondary">
//                       No categories found.
//                     </Typography>
//                   </TableCell>
//                 </TableRow>
//               ) : (
//                 categoryItems.map((item, index) => (
//                   <StyledTableRow key={item.id}>
//                     <StyledTableCell align="center">
//                       <Typography 
//                         variant="body2" 
//                         color="text.secondary"
//                         sx={{ 
//                           fontWeight: 500,
//                         }}
//                       >
//                         {index + 1}
//                       </Typography>
//                     </StyledTableCell>
//                     <StyledTableCell align="center">
//                       <Typography variant="body1" fontWeight={500} sx={{ color: 'text.primary' }}>
//                         {item.name}
//                       </Typography>
//                     </StyledTableCell>
//                     <StyledTableCell align="center">
//                       <Box display="flex" gap={1} justifyContent="center" alignItems="center">
//                         <Tooltip title="Edit">
//                           <IconButton color="primary" size="small" onClick={() => handleCategoryOpenDialog(item)}>
//                             <Edit fontSize="small" />
//                           </IconButton>
//                         </Tooltip>
//                         <Tooltip title="Delete">
//                           <span>
//                             <IconButton
//                               color="error"
//                               size="small"
//                               onClick={() => handleCategoryDelete(item.id)}
//                               disabled={categoryDeletingId === item.id}
//                             >
//                               {categoryDeletingId === item.id ? (
//                                 <CircularProgress size={18} />
//                               ) : (
//                                 <Delete fontSize="small" />
//                               )}
//                             </IconButton>
//                           </span>
//                         </Tooltip>
//                       </Box>
//                     </StyledTableCell>
//                   </StyledTableRow>
//                 ))
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       </TableCard>
//     </>
//   );

//   // Render Subcategory Tab
//   const renderSubcategoryTab = () => (
//     <>
//       <HeaderCard>
//         <Box>
//           <Typography variant="h6" fontWeight={700}>
//             Subcategories
//           </Typography>
//           <Muted variant="body2">Manage disease advisory subcategories</Muted>
//         </Box>
//         <Box sx={{ display: "flex", gap: 2 }}>
//           <Button
//             startIcon={<Add />}
//             variant="contained"
//             onClick={() => handleSubcategoryOpenDialog()}
//           >
//             Add Subcategory
//           </Button>
//           <Button startIcon={<Refresh />} variant="outlined" onClick={fetchSubcategoryItems} disabled={loading}>
//             {loading ? "Refreshing..." : "Refresh"}
//           </Button>
//         </Box>
//       </HeaderCard>

//       <TableCard>
//         <TableContainer component={Paper} sx={{ borderRadius: 2, overflow: "hidden" }}>
//           <Table>
//             <TableHead>
//               <TableRow>
//                 <StyledTableCell className="header" align="center" sx={{ width: '100px' }}>Sr No</StyledTableCell>
//                 <StyledTableCell className="header" align="center">Subcategory</StyledTableCell>
//                 <StyledTableCell className="header" align="center">Category</StyledTableCell>
//                 <StyledTableCell className="header" align="center" sx={{ width: '150px' }}>Actions</StyledTableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {loading ? (
//                 <TableRow>
//                   <TableCell colSpan={4} align="center" sx={{ py: 5 }}>
//                     <CircularProgress size={28} />
//                   </TableCell>
//                 </TableRow>
//               ) : subcategoryItems.length === 0 ? (
//                 <TableRow>
//                   <TableCell colSpan={4} align="center" sx={{ py: 4 }}>
//                     <Typography variant="body2" color="text.secondary">
//                       No subcategories found.
//                     </Typography>
//                   </TableCell>
//                 </TableRow>
//               ) : (
//                 subcategoryItems.map((item, index) => (
//                   <StyledTableRow key={item.id}>
//                     <StyledTableCell align="center">
//                       <Typography 
//                         variant="body2" 
//                         color="text.secondary"
//                         sx={{ 
//                           fontWeight: 500,
//                         }}
//                       >
//                         {index + 1}
//                       </Typography>
//                     </StyledTableCell>
//                     <StyledTableCell align="center">
//                       <Typography variant="body1" fontWeight={500} sx={{ color: 'text.primary' }}>
//                         {item.name}
//                       </Typography>
//                     </StyledTableCell>
//                     <StyledTableCell align="center">
//                       <Typography variant="body2">
//                         {item.category?.name || item.category_name || "N/A"}
//                       </Typography>
//                     </StyledTableCell>
//                     <StyledTableCell align="center">
//                       <Box display="flex" gap={1} justifyContent="center" alignItems="center">
//                         <Tooltip title="Edit">
//                           <IconButton color="primary" size="small" onClick={() => handleSubcategoryOpenDialog(item)}>
//                             <Edit fontSize="small" />
//                           </IconButton>
//                         </Tooltip>
//                         <Tooltip title="Delete">
//                           <span>
//                             <IconButton
//                               color="error"
//                               size="small"
//                               onClick={() => handleSubcategoryDelete(item.id)}
//                               disabled={subcategoryDeletingId === item.id}
//                             >
//                               {subcategoryDeletingId === item.id ? (
//                                 <CircularProgress size={18} />
//                               ) : (
//                                 <Delete fontSize="small" />
//                               )}
//                             </IconButton>
//                           </span>
//                         </Tooltip>
//                       </Box>
//                     </StyledTableCell>
//                   </StyledTableRow>
//                 ))
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       </TableCard>
//     </>
//   );

//   // Render FAQ Tab
//   const renderFaqTab = () => (
//     <>
//       <HeaderCard>
//         <Box>
//           <Typography variant="h6" fontWeight={700}>
//             FAQs
//           </Typography>
//           <Muted variant="body2">Manage frequently asked questions</Muted>
//         </Box>
//         <Box sx={{ display: "flex", gap: 2 }}>
//           <Button
//             startIcon={<Add />}
//             variant="contained"
//             onClick={() => handleFaqOpenDialog()}
//           >
//             Add FAQ
//           </Button>
//           <Button startIcon={<Refresh />} variant="outlined" onClick={fetchFaqItems} disabled={loading}>
//             {loading ? "Refreshing..." : "Refresh"}
//           </Button>
//         </Box>
//       </HeaderCard>

//       <TableCard>
//         <TableContainer component={Paper} sx={{ borderRadius: 2, overflow: "hidden" }}>
//           <Table>
//             <TableHead>
//               <TableRow>
//                 <StyledTableCell className="header">Sr No</StyledTableCell>
//                 <StyledTableCell className="header">Question</StyledTableCell>
//                 <StyledTableCell className="header">Category</StyledTableCell>
//                 <StyledTableCell className="header">Subcategory</StyledTableCell>
//                 <StyledTableCell className="header">Actions</StyledTableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {loading ? (
//                 <TableRow>
//                   <TableCell colSpan={5} align="center" sx={{ py: 5 }}>
//                     <CircularProgress size={28} />
//                   </TableCell>
//                 </TableRow>
//               ) : faqItems.length === 0 ? (
//                 <TableRow>
//                   <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
//                     <Typography variant="body2" color="text.secondary">
//                       No FAQs found.
//                     </Typography>
//                   </TableCell>
//                 </TableRow>
//               ) : (
//                 faqItems.map((item, index) => (
//                   <StyledTableRow key={item.id}>
//                     <StyledTableCell>
//                       <Chip label={`#${index + 1}`} size="small" color="primary" variant="outlined" />
//                     </StyledTableCell>
//                     <StyledTableCell>
//                       <Typography variant="body2" sx={{ maxWidth: 400, overflow: "hidden", textOverflow: "ellipsis" }}>
//                         {item.question || item.prompt || "N/A"}
//                       </Typography>
//                     </StyledTableCell>
//                     <StyledTableCell>
//                       <Typography variant="body2">
//                         {item.category_name || "N/A"}
//                       </Typography>
//                     </StyledTableCell>
//                     <StyledTableCell>
//                       <Typography variant="body2">
//                         {item.sub_category_name || "N/A"}
//                       </Typography>
//                     </StyledTableCell>
//                     <StyledTableCell>
//                       <Box display="flex" gap={1}>
//                         <Tooltip title="Edit">
//                           <IconButton color="primary" onClick={() => handleFaqOpenDialog(item)}>
//                             <Edit />
//                           </IconButton>
//                         </Tooltip>
//                         <Tooltip title="Delete">
//                           <span>
//                             <IconButton
//                               color="error"
//                               onClick={() => handleFaqDelete(item.id)}
//                               disabled={faqDeletingId === item.id}
//                             >
//                               {faqDeletingId === item.id ? (
//                                 <CircularProgress size={18} />
//                               ) : (
//                                 <Delete />
//                               )}
//                             </IconButton>
//                           </span>
//                         </Tooltip>
//                       </Box>
//                     </StyledTableCell>
//                   </StyledTableRow>
//                 ))
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       </TableCard>
//     </>
//   );

//   return (
//     <PageContainer>
//       <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
//         <Tabs value={currentTab} onChange={(e, newValue) => setCurrentTab(newValue)}>
//           <Tab label="Categories" />
//           {/* <Tab label="Subcategories" />
//           <Tab label="FAQs" /> */}
//         </Tabs>
//       </Box>

//       {currentTab === 0 && renderCategoryTab()}
//       {currentTab === 1 && renderSubcategoryTab()}
//       {currentTab === 2 && renderFaqTab()}

//       {/* Category Dialog */}
//       <Dialog open={categoryDialogOpen} onClose={handleCategoryCloseDialog} maxWidth="sm" fullWidth>
//         <DialogTitle>
//           <Box display="flex" justifyContent="space-between" alignItems="center">
//             <Typography variant="h6">
//               {categoryEditingId ? "Edit Category" : "Add Category"}
//             </Typography>
//             <IconButton onClick={handleCategoryCloseDialog} size="small">
//               <Close />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Box sx={{ display: "flex", flexDirection: "column", gap: 3, pt: 2 }}>
//             <TextField
//               label="Category Name *"
//               value={categoryFormData.name}
//               onChange={(e) => setCategoryFormData((prev) => ({ ...prev, name: e.target.value }))}
//               fullWidth
//               autoFocus
//             />
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCategoryCloseDialog} disabled={categorySaving}>
//             Cancel
//           </Button>
//           <Button
//             onClick={handleCategorySave}
//             variant="contained"
//             disabled={categorySaving || !categoryFormData.name?.trim()}
//             startIcon={categorySaving ? <CircularProgress size={16} /> : <Save />}
//           >
//             {categorySaving ? "Saving..." : categoryEditingId ? "Update" : "Add"}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Subcategory Dialog */}
//       <Dialog open={subcategoryDialogOpen} onClose={handleSubcategoryCloseDialog} maxWidth="sm" fullWidth>
//         <DialogTitle>
//           <Box display="flex" justifyContent="space-between" alignItems="center">
//             <Typography variant="h6">
//               {subcategoryEditingId ? "Edit Subcategory" : "Add Subcategory"}
//             </Typography>
//             <IconButton onClick={handleSubcategoryCloseDialog} size="small">
//               <Close />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Box sx={{ display: "flex", flexDirection: "column", gap: 3, pt: 2 }}>
//             <FormControl fullWidth>
//               <InputLabel>Category *</InputLabel>
//               <Select
//                 value={subcategoryFormData.category_id}
//                 onChange={(e) => setSubcategoryFormData((prev) => ({ ...prev, category_id: e.target.value }))}
//                 label="Category *"
//                 disabled={loadingCategories}
//               >
//                 {categories.map((category) => (
//                   <MenuItem key={category.id} value={category.id}>
//                     {category.name}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//             <TextField
//               label="Subcategory Name *"
//               value={subcategoryFormData.name}
//               onChange={(e) => setSubcategoryFormData((prev) => ({ ...prev, name: e.target.value }))}
//               fullWidth
//             />
//             <TextField
//               label="Sequence"
//               type="number"
//               value={subcategoryFormData.sequence}
//               onChange={(e) => setSubcategoryFormData((prev) => ({ ...prev, sequence: e.target.value }))}
//               fullWidth
//             />
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleSubcategoryCloseDialog} disabled={subcategorySaving}>
//             Cancel
//           </Button>
//           <Button
//             onClick={handleSubcategorySave}
//             variant="contained"
//             disabled={subcategorySaving || !subcategoryFormData.name?.trim() || !subcategoryFormData.category_id}
//             startIcon={subcategorySaving ? <CircularProgress size={16} /> : <Save />}
//           >
//             {subcategorySaving ? "Saving..." : subcategoryEditingId ? "Update" : "Add"}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* FAQ Dialog */}
//       <Dialog open={faqDialogOpen} onClose={handleFaqCloseDialog} maxWidth="md" fullWidth>
//         <DialogTitle>
//           <Box display="flex" justifyContent="space-between" alignItems="center">
//             <Typography variant="h6">
//               {faqEditingId ? "Edit FAQ" : "Add FAQ"}
//             </Typography>
//             <IconButton onClick={handleFaqCloseDialog} size="small">
//               <Close />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Box sx={{ display: "flex", flexDirection: "column", gap: 3, pt: 2 }}>
//             <FormControl fullWidth>
//               <InputLabel>Category *</InputLabel>
//               <Select
//                 value={faqFormData.category_id || ""}
//                 onChange={(e) => {
//                   setFaqFormData((prev) => ({ ...prev, category_id: String(e.target.value), subcategory_id: "" }));
//                   if (e.target.value) {
//                     fetchSubcategories(Number(e.target.value));
//                   }
//                 }}
//                 label="Category *"
//                 disabled={loadingCategories}
//               >
//                 {categories.map((category) => (
//                   <MenuItem key={category.id} value={String(category.id)}>
//                     {category.name}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//             <FormControl fullWidth>
//               <InputLabel>Subcategory *</InputLabel>
//               <Select
//                 value={faqFormData.subcategory_id || ""}
//                 onChange={(e) => setFaqFormData((prev) => ({ ...prev, subcategory_id: String(e.target.value) }))}
//                 label="Subcategory *"
//                 disabled={!faqFormData.category_id || loadingSubcategories}
//               >
//                 {!faqFormData.category_id ? (
//                   <MenuItem disabled>Please select a category first</MenuItem>
//                 ) : (
//                   subcategories.map((subcategory) => (
//                     <MenuItem key={subcategory.id} value={String(subcategory.id)}>
//                       {subcategory.name}
//                     </MenuItem>
//                   ))
//                 )}
//               </Select>
//             </FormControl>
//             <TextField
//               label="Question *"
//               multiline
//               rows={4}
//               value={faqFormData.question}
//               onChange={(e) => setFaqFormData((prev) => ({ ...prev, question: e.target.value }))}
//               fullWidth
//               placeholder="Enter FAQ question..."
//             />
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleFaqCloseDialog} disabled={faqSaving}>
//             Cancel
//           </Button>
//           <Button
//             onClick={handleFaqSave}
//             variant="contained"
//             disabled={faqSaving || !faqFormData.question?.trim() || !faqFormData.category_id || !faqFormData.subcategory_id}
//             startIcon={faqSaving ? <CircularProgress size={16} /> : <Save />}
//           >
//             {faqSaving ? "Saving..." : faqEditingId ? "Update" : "Add"}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </PageContainer>
//   );
// };

// export default InvoiceDetails;
import { useEffect, useState, useCallback } from "react";
import {
  Box,
  Card,
  Typography,
  IconButton,
  TextField,
  Button,
  Divider,
  CircularProgress,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  // FormControl,
  InputLabel,
  Select,
  MenuItem,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Chip,
  Avatar,
  Checkbox,
  FormControlLabel,
  Pagination,
  FormControl,
} from "@mui/material";
import { Delete, Edit, Save, Close, Refresh, Add, Visibility } from "@mui/icons-material";
import { styled, useTheme } from "@mui/material/styles";
import apiService from "Network/apiService";
import { API_ENDPOINTS } from "Network/apiEndpoints";
import { useToast } from "OtherReusableFunctionality/ToastContext";
import { usePageTitle } from "contexts/PageTitleContext";
import { useDeleteConfirmation } from "contexts/DeleteConfirmationContext";

const PageContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}));

const HeaderCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: "0.875rem",
  padding: "12px 16px",
  "&.header": {
    fontWeight: 600,
    backgroundColor: theme.palette.grey[100],
    position: 'sticky',
    top: 0,
    zIndex: 1,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));

const TableCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2),
}));

const Muted = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

const ImageContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 8,
});

const InvoiceDetails = () => {
  const theme = useTheme();
  const toast = useToast();
  const { setPageTitle } = usePageTitle();
  const { showDeleteConfirmation } = useDeleteConfirmation();

  // Loading state
  const [loading, setLoading] = useState(false);
  const isCompanyUser = apiService.isCompanyUser();
  const companyId = apiService.getCompanyId();
  const companyDetails = apiService.getCompanyDetails();
  
  // Invoice data
  const [invoices, setInvoices] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [loadingCompanies, setLoadingCompanies] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(isCompanyUser ? companyId : 'all');
  
  // Invoice Dialog states
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    company: "",
    name: "",
    address: "",
    mobile_number: "",
    logo_image: null,
    stamp_image: null,
    gst_number: "",
    registration_number: "",
    certification_number: "",
    terms_and_conditions: "",
    is_global: false,
  });
  const [logoPreview, setLogoPreview] = useState("");
  const [stampPreview, setStampPreview] = useState("");
  const [saving, setSaving] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [pagination, setPagination] = useState({
    current_page: 1,
    page_size: 10,
    total_items: 0,
    total_pages: 1,
    has_next: false,
    has_previous: false,
    next_page_number: null,
    previous_page_number: null,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const pageSizeOptions = [10, 25, 50, 100];

  useEffect(() => {
    setPageTitle("Category Details");
    fetchInvoices(1, 10);
    fetchCompanies();
  }, [setPageTitle]);

  const userId = localStorage.getItem("user_id") || "1";

  // Fetch invoices with pagination
  const fetchInvoices = async (pageParam = 1, pageSizeParam = 10) => {
    setLoading(true);
    try {
      const url = `${API_ENDPOINTS.Get_Invoice}${API_ENDPOINTS.Get_Invoice.includes("?") ? "&" : "?"}page=${pageParam}&page_size=${pageSizeParam}`;
      const response = await apiService.get(url);
      
      if (response?.success && response?.data) {
        const invoiceList = response.data.InvoiceDetailsOfCompany || 
                           response.data.invoiceDetailsOfCompany || 
                           (Array.isArray(response.data) ? response.data : []);
        const activeInvoices = (Array.isArray(invoiceList) ? invoiceList : []).filter((inv) => !inv.is_deleted);
        setInvoices(activeInvoices);
        
        const paginationData = response?.pagination || response?.data?.pagination || {};
        if (Object.keys(paginationData).length > 0) {
          setPagination({
            current_page: paginationData.current_page ?? pageParam,
            page_size: paginationData.page_size ?? pageSizeParam,
            total_items: paginationData.total_items ?? 0,
            total_pages: paginationData.total_pages ?? 1,
            has_next: paginationData.has_next ?? false,
            has_previous: paginationData.has_previous ?? false,
            next_page_number: paginationData.next_page_number ?? null,
            previous_page_number: paginationData.previous_page_number ?? null,
          });
          setCurrentPage(paginationData.current_page ?? pageParam);
          setPageSize(paginationData.page_size ?? pageSizeParam);
        } else {
          setPagination(prev => ({ ...prev, total_items: activeInvoices.length, total_pages: 1, current_page: 1, page_size: pageSizeParam }));
        }
      } else {
        toast.showError("Failed to load categories: Invalid response");
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      toast.showError("Failed to load categories");
    } finally {
      setLoading(false);
    }
  };

  const handleInvoicePageChange = (_, value) => {
    setCurrentPage(value);
    fetchInvoices(value, pageSize);
  };

  const handleInvoicePageSizeChange = (e) => {
    const newSize = Number(e.target.value);
    setPageSize(newSize);
    setCurrentPage(1);
    fetchInvoices(1, newSize);
  };

  const handleCompanyChange = (event) => {
    setSelectedCompany(event.target.value);
  };

  const fetchCompanies = async () => {
    try {
      // If Company user, create a company array with their company details
      if (isCompanyUser && companyDetails) {
        setCompanies([companyDetails]);
        return;
      }
      
      const res = await apiService.get(API_ENDPOINTS.GET_company);
      if (res?.success) {
        const companyList = res.data?.Company || [];
        setCompanies(companyList);
      }
    } catch (error) {
      console.error('Error fetching companies:', error);
    }
  };

  // Handle dialog open
  const handleOpenDialog = (invoice = null) => {
    if (invoice) {
      setEditingId(invoice.id);
      setFormData({
        company: invoice.company?.id || "",
        name: invoice.name || "",
        address: invoice.address || "",
        mobile_number: invoice.mobile_number || "",
        logo_image: null,
        stamp_image: null,
        gst_number: invoice.gst_number || "",
        registration_number: invoice.registration_number || "",
        certification_number: invoice.certification_number || "",
        terms_and_conditions: invoice.terms_and_conditions || "",
        is_global: invoice.is_global || false,
      });
      setLogoPreview(invoice.logo_url || "");
      setStampPreview(invoice.stamp_url || "");
    } else {
      setEditingId(null);
      setFormData({
        company: isCompanyUser ? companyId : "",
        name: "",
        address: "",
        mobile_number: "",
        logo_image: null,
        stamp_image: null,
        gst_number: "",
        registration_number: "",
        certification_number: "",
        terms_and_conditions: "",
        is_global: false,
      });
      setLogoPreview("");
      setStampPreview("");
    }
    setDialogOpen(true);
  };

  // Handle dialog close
  const handleCloseDialog = () => {
    setDialogOpen(false);
    setEditingId(null);
    setFormData({
      company: isCompanyUser ? companyId : "",
      name: "",
      address: "",
      mobile_number: "",
      logo_image: null,
      stamp_image: null,
      gst_number: "",
      registration_number: "",
      certification_number: "",
      terms_and_conditions: "",
      is_global: false,
    });
    setLogoPreview("");
    setStampPreview("");
  };

  // Handle image file changes
  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({ ...prev, logo_image: file }));
      setLogoPreview(URL.createObjectURL(file));
    }
  };

  const handleStampChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({ ...prev, stamp_image: file }));
      setStampPreview(URL.createObjectURL(file));
    }
  };

  // Handle save invoice - UPDATED TO MATCH CURL FORMAT
  const handleSave = async () => {
    if (!formData.company || !formData.name?.trim()) {
      toast.showError("Company and Name are required");
      return;
    }

    // Validate company exists in the list
    const selectedCompanyObj = companies.find(c => String(c.id) === String(formData.company));
    if (!selectedCompanyObj) {
      toast.showError(`Company with ID ${formData.company} not found. Please refresh the page.`);
      return;
    }

    setSaving(true);
    try {
      const formDataPayload = new FormData();
      
      // Append all fields exactly as they appear in cURL
      formDataPayload.append('company', String(formData.company));
      formDataPayload.append('name', formData.name.trim());
      formDataPayload.append('address', formData.address?.trim() || '');
      formDataPayload.append('mobile_number', formData.mobile_number?.trim() || '');
      formDataPayload.append('gst_number', formData.gst_number?.trim() || '');
      formDataPayload.append('registration_number', formData.registration_number?.trim() || '');
      formDataPayload.append('certification_number', formData.certification_number?.trim() || '');
      formDataPayload.append('terms_and_conditions', formData.terms_and_conditions?.trim() || '');
      formDataPayload.append('is_global', formData.is_global ? "true" : "false");
      
      // Append logo file if selected
      if (formData.logo_image instanceof File) {
        formDataPayload.append('logo_image', formData.logo_image);
      }
      
      // Append stamp file if selected
      if (formData.stamp_image instanceof File) {
        formDataPayload.append('stamp_image', formData.stamp_image);
      }
      
      // For updates, append the invoice ID
      if (editingId) {
        formDataPayload.append('invoice_details_of_company_id', String(editingId));
      }

      // Debug: Log FormData contents
      console.log('FormData contents being sent:');
      for (let pair of formDataPayload.entries()) {
        if (pair[1] instanceof File) {
          console.log(`${pair[0]}: File - ${pair[1].name}, Size: ${pair[1].size} bytes`);
        } else {
          console.log(`${pair[0]}: ${pair[1]}`);
        }
      }

      let response;
      if (editingId) {
        // For UPDATE - using PUT method
        response = await apiService.put(
          API_ENDPOINTS.Update_Invoice,
          formDataPayload,
          'multipart/form-data'
        );
      } else {
        // For ADD - using POST method
        response = await apiService.post(
          API_ENDPOINTS.Add_Invoice,
          formDataPayload,
          'multipart/form-data'
        );
      }

      console.log('API Response:', response);

      if (response?.success) {
        toast.showSuccess(editingId ? "Category Details updated successfully" : "Category Details added successfully");
        handleCloseDialog();
        await fetchInvoices(currentPage, pageSize);
      } else {
        const errorMsg = response?.message || response?.error || "Failed to save category details";
        toast.showError(errorMsg);
      }
    } catch (error) {
      console.error("Error saving category details:", error);
      
      if (error.response) {
        console.error("Response status:", error.response.status);
        console.error("Response data:", error.response.data);
        console.error("Response headers:", error.response.headers);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error message:", error.message);
      }
      
      const errorMessage = error?.response?.data?.message || 
                          error?.response?.data?.error || 
                          error?.message || 
                          "Failed to save category details";
      toast.showError(errorMessage);
    } finally {
      setSaving(false);
    }
  };

  // Handle delete invoice - FIXED VERSION
  const handleDelete = async (id, e) => {
    // Prevent event bubbling
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    
    console.log('Delete clicked for invoice ID:', id); // Debug log
    
    const confirmed = await showDeleteConfirmation({
      title: "Delete Category",
      message: "Are you sure you want to delete this category?",
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel"
    });
    
    if (!confirmed) return;
    
    setDeletingId(id);
    try {
      console.log('Calling delete API for category ID:', id); // Debug log
      
      const response = await apiService.delete(
        `${API_ENDPOINTS.Delete_Invoice}?invoice_details_of_company_id=${id}`
      );
      
      console.log('Delete API response:', response); // Debug log
      
      if (response?.success) {
        toast.showSuccess("Category deleted successfully");
        // Update the local state immediately for better UX
        setInvoices(prev => prev.filter(invoice => invoice.id !== id));
        // Also refetch to ensure sync with backend
        await fetchInvoices(currentPage, pageSize);
      } else {
        toast.showError(response?.message || "Failed to delete category");
      }
    } catch (error) {
      console.error("Error deleting category:", error);
      toast.showError(error?.message || "Failed to delete category");
    } finally {
      setDeletingId(null);
    }
  };

  // Handle edit invoice - FIXED VERSION
  const handleEdit = (invoice, e) => {
    // Prevent event bubbling
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }

    console.log('Edit clicked for category:', invoice); // Debug log
    handleOpenDialog(invoice);
  };

  return (
    <PageContainer>
      <HeaderCard>
        <Box>
          <Typography variant="h6" fontWeight={700}>
            Category Details
          </Typography>
          <Muted variant="body2">Manage company information</Muted>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <FormControl size="small" sx={{ minWidth: 110 }}>
            <InputLabel>Rows</InputLabel>
            <Select value={pageSize} label="Rows" onChange={handleInvoicePageSizeChange}>
              {pageSizeOptions.map((opt) => (
                <MenuItem key={opt} value={opt}>{opt}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            startIcon={<Add />}
            variant="contained"
            onClick={() => handleOpenDialog()}
          >
            Add Category
          </Button>
          <Button startIcon={<Refresh />} variant="outlined" onClick={() => fetchInvoices(currentPage, pageSize)} disabled={loading}>
            {loading ? "Refreshing..." : "Refresh"}
          </Button>
        </Box>
      </HeaderCard>

      <TableCard>
        <TableContainer 
          component={Paper} 
          sx={{ 
            borderRadius: 2, 
            overflowX: "auto",
            maxHeight: 600,
            position: 'relative',
             /* Firefox */
            scrollbarWidth: "thin",
            scrollbarColor:
              theme.palette.mode === "dark"
                ? "#555 #1e1e1e"
                : "#c1c1c1 #f1f1f1",

            /* Chrome, Edge, Safari */
            "&::-webkit-scrollbar": {
              height: 8,
              width: 8,
            },
            "&::-webkit-scrollbar-track": {
              background:
                theme.palette.mode === "dark"
                  ? "#1e1e1e"
                  : "#f1f1f1",
              borderRadius: 8,
            },
            "&::-webkit-scrollbar-thumb": {
              background:
                theme.palette.mode === "dark"
                  ? "#555"
                  : "#c1c1c1",
              borderRadius: 8,
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background:
                theme.palette.mode === "dark"
                  ? "#777"
                  : "#a8a8a8",
            },
          }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell className="header" align="center" sx={{ width: '80px' }}>Sr No</StyledTableCell>
                <StyledTableCell className="header" align="center">Company</StyledTableCell>
                <StyledTableCell className="header" align="center">Invoice Name</StyledTableCell>
                <StyledTableCell className="header" align="center">Address</StyledTableCell>
                <StyledTableCell className="header" align="center">Contact On</StyledTableCell>
                <StyledTableCell className="header" align="center">Logo</StyledTableCell>
                <StyledTableCell className="header" align="center">Stamp</StyledTableCell>
                <StyledTableCell className="header" align="center">GST Number</StyledTableCell>
                <StyledTableCell className="header" align="center">Reg. No</StyledTableCell>
                <StyledTableCell className="header" align="center">Cert. No</StyledTableCell>
                <StyledTableCell className="header" align="center">Global</StyledTableCell>
                <StyledTableCell 
                  className="header" 
                  align="center" 
                  sx={{ 
                    width: '150px',
                    position: 'sticky !important',
                    top: '0 !important',
                    right: 0,
                    zIndex: '11 !important',
                    backgroundColor: (theme) => `${theme.palette.grey[100]} !important`,
                    boxShadow: (theme) => `-2px 0 4px -2px ${theme.palette.divider}`
                  }}
                >
                  Actions
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={12} align="center" sx={{ py: 5 }}>
                    <CircularProgress size={28} />
                    <Typography variant="body2" sx={{ mt: 1 }}>Loading invoices...</Typography>
                  </TableCell>
                </TableRow>
              ) : invoices.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={12} align="center" sx={{ py: 4 }}>
                    <Typography variant="body2" color="text.secondary">
                      No invoices found. Click "Add Invoice" to create one.
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                invoices.map((invoice, index) => (
                  <StyledTableRow 
                    key={invoice.id}
                    sx={{ '&:hover': { backgroundColor: theme.palette.action.hover } }}
                  >
                    <StyledTableCell align="center">
                      <Chip label={`#${(pagination.current_page - 1) * pagination.page_size + index + 1}`} size="small" color="primary" variant="outlined" />
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Typography variant="body2" fontWeight={500}>
                        {invoice.company?.name || "N/A"}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        ID: {invoice.company?.id || "N/A"}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Typography variant="body1" fontWeight={600} sx={{ color: 'text.primary' }}>
                        {invoice.name}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {invoice.address ? (
                        <Tooltip title={invoice.address} arrow placement="top">
                          <Typography 
                            variant="body2"
                            sx={{
                              display: '-webkit-box',
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              cursor: 'help',
                              lineHeight: 1.4,
                              maxHeight: '2.8em',
                              maxWidth: '200px',
                              margin: '0 auto'
                            }}
                          >
                            {invoice.address}
                          </Typography>
                        </Tooltip>
                      ) : (
                        <Typography variant="body2">N/A</Typography>
                      )}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Typography variant="body2">
                        {invoice.mobile_number || "N/A"}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <ImageContainer justifyContent="center">
                        {invoice.logo_url ? (
                          <Avatar
                            src={invoice.logo_url}
                            alt="Logo"
                            sx={{ width: 40, height: 40 }}
                            variant="rounded"
                          />
                        ) : (
                          <Typography variant="body2" color="text.secondary">
                            No Logo
                          </Typography>
                        )}
                      </ImageContainer>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <ImageContainer justifyContent="center">
                        {invoice.stamp_url ? (
                          <Avatar
                            src={invoice.stamp_url}
                            alt="Stamp"
                            sx={{ width: 40, height: 40 }}
                            variant="rounded"
                          />
                        ) : (
                          <Typography variant="body2" color="text.secondary">
                            No Stamp
                          </Typography>
                        )}
                      </ImageContainer>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Typography variant="body2">
                        {invoice.gst_number || "N/A"}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Typography variant="body2">
                        {invoice.registration_number || "N/A"}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Typography variant="body2">
                        {invoice.certification_number || "N/A"}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Chip
                        label={invoice.is_global ? "Yes" : "No"}
                        size="small"
                        color={invoice.is_global ? "success" : "default"}
                        variant="outlined"
                      />
                    </StyledTableCell>
                    <StyledTableCell 
                      align="center"
                      sx={{
                        position: 'sticky',
                        right: 0,
                        zIndex: 4,
                        backgroundColor: (theme) => theme.palette.background.paper
                      }}
                    >
                      <Box 
                        display="flex" 
                        gap={1} 
                        justifyContent="center" 
                        alignItems="center"
                        onClick={(e) => e.stopPropagation()} // Prevent row click from affecting buttons
                      >
                        <Tooltip title="Edit">
                          <span>
                            <IconButton 
                              color="primary" 
                              size="small" 
                              onClick={(e) => handleEdit(invoice, e)}
                            >
                              <Edit fontSize="small" />
                            </IconButton>
                          </span>
                        </Tooltip>
                        <Tooltip title="Delete">
                          <span>
                            <IconButton
                              color="error"
                              size="small"
                              onClick={(e) => handleDelete(invoice.id, e)}
                              disabled={deletingId === invoice.id}
                            >
                              {deletingId === invoice.id ? (
                                <CircularProgress size={18} />
                              ) : (
                                <Delete fontSize="small" />
                              )}
                            </IconButton>
                          </span>
                        </Tooltip>
                      </Box>
                    </StyledTableCell>
                  </StyledTableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </TableCard>

      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 2, flexWrap: 'wrap', gap: 2 }}>
        <Typography variant="body2" color="text.secondary">
          {pagination.total_items > 0
            ? `Showing ${(pagination.current_page - 1) * pagination.page_size + 1} - ${Math.min(pagination.current_page * pagination.page_size, pagination.total_items)} of ${pagination.total_items}`
            : (invoices.length > 0 ? `Showing ${invoices.length} items` : 'No items')}
        </Typography>
        {pagination.total_pages > 1 && (
          <Pagination count={pagination.total_pages} page={currentPage} onChange={handleInvoicePageChange} color="primary" />
        )}
      </Box>

      {/* Invoice Dialog */}
      <Dialog open={dialogOpen} onClose={handleCloseDialog} maxWidth="md" fullWidth scroll="paper">
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">
              {editingId ? "Edit Category Details" : "Add Category Details"}
            </Typography>
            <IconButton onClick={handleCloseDialog} size="small">
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3, pt: 2 }}>
            <FormControl fullWidth required>
              <InputLabel>Company </InputLabel>
              <Select 
                value={formData.company} 
                label="Company " 
                onChange={(e) => setFormData(prev => ({ ...prev, company: e.target.value }))}
                disabled={isCompanyUser}
              >
                {isCompanyUser && companyDetails ? (
                  <MenuItem value={companyDetails.id}>
                    <Chip label={companyDetails.name} size="small" color="secondary" variant="outlined" sx={{ mr: 1 }} />
                    {companyDetails.name}
                  </MenuItem>
                ) : (
                  companies.map((company) => (
                    <MenuItem key={company.id} value={company.id}>
                      <Chip label={company.name} size="small" color="secondary" variant="outlined" sx={{ mr: 1 }} />
                      {company.name}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>

            <TextField
              label="Invoice Name "
              value={formData.name}
              onChange={(e) => setFormData((prev) => ({ ...prev, name: e.target.value }))}
              fullWidth
              required
              error={!formData.name.trim()}
              helperText={!formData.name.trim() ? "Invoice name is required" : ""}
            />

            <TextField
              label="Address"
              value={formData.address}
              onChange={(e) => setFormData((prev) => ({ ...prev, address: e.target.value }))}
              fullWidth
              multiline
              rows={2}
              placeholder="Company address for invoice"
            />

            <TextField
              label="Contact On"
              value={formData.mobile_number}
              onChange={(e) => setFormData((prev) => ({ ...prev, mobile_number: e.target.value }))}
              fullWidth
              placeholder="Contact number for invoice"
            />

            <Box sx={{ display: "flex", gap: 3 }}>
              <Box sx={{ flex: 1 }}>
                <Typography variant="body2" sx={{ mb: 1 }}>Logo Image</Typography>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleLogoChange}
                  style={{ display: 'none' }}
                  id="logo-upload"
                />
                <label htmlFor="logo-upload">
                  <Button variant="outlined" component="span" fullWidth>
                    {logoPreview ? "Change Logo Image" : "Upload Logo Image"}
                  </Button>
                </label>
                {logoPreview && (
                  <Box sx={{ mt: 2, display: "flex", alignItems: "center", gap: 2 }}>
                    <Avatar src={logoPreview} alt="Logo Preview" sx={{ width: 60, height: 60 }} variant="rounded" />
                    <Typography variant="body2" color="text.secondary">
                      {formData.logo_image?.name || "Logo selected"}
                    </Typography>
                  </Box>
                )}
              </Box>

              <Box sx={{ flex: 1 }}>
                <Typography variant="body2" sx={{ mb: 1 }}>Stamp Image</Typography>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleStampChange}
                  style={{ display: 'none' }}
                  id="stamp-upload"
                />
                <label htmlFor="stamp-upload">
                  <Button variant="outlined" component="span" fullWidth>
                    {stampPreview ? "Change Stamp Image" : "Upload Stamp Image"}
                  </Button>
                </label>
                {stampPreview && (
                  <Box sx={{ mt: 2, display: "flex", alignItems: "center", gap: 2 }}>
                    <Avatar src={stampPreview} alt="Stamp Preview" sx={{ width: 60, height: 60 }} variant="rounded" />
                    <Typography variant="body2" color="text.secondary">
                      {formData.stamp_image?.name || "Stamp selected"}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>

            <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 3 }}>
              <TextField
                label="GST Number"
                value={formData.gst_number}
                onChange={(e) => setFormData((prev) => ({ ...prev, gst_number: e.target.value }))}
                fullWidth
                placeholder="GST number for invoice"
              />

              <TextField
                label="Registration Number"
                value={formData.registration_number}
                onChange={(e) => setFormData((prev) => ({ ...prev, registration_number: e.target.value }))}
                fullWidth
                placeholder="Registration number"
              />

              <TextField
                label="Certification Number"
                value={formData.certification_number}
                onChange={(e) => setFormData((prev) => ({ ...prev, certification_number: e.target.value }))}
                fullWidth
                placeholder="Certification number (if any)"
              />
            </Box>

            <TextField
              label="Terms and Conditions"
              value={formData.terms_and_conditions}
              onChange={(e) => setFormData((prev) => ({ ...prev, terms_and_conditions: e.target.value }))}
              fullWidth
              multiline
              rows={4}
              placeholder="Enter terms and conditions for the invoice"
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.is_global}
                  onChange={(e) => setFormData((prev) => ({ ...prev, is_global: e.target.checked }))}
                />
              }
              label="Set as Global Invoice"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} disabled={saving}>
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            variant="contained"
            disabled={saving || !formData.company || !formData.name?.trim()}
            startIcon={saving ? <CircularProgress size={16} /> : <Save />}
          >
            {saving ? "Saving..." : editingId ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>
    </PageContainer>
  );
};

export default InvoiceDetails;